import {AfterContentChecked, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ClienteComponent} from '../../components/cliente/cliente.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PageService} from '../services/page.service';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {ModalInjectorService} from '../services/modal-injector.service';
import Swal from 'sweetalert2';
import {ObservacionModalComponent} from '../modal/observacion-modal/observacion-modal.component';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-baja',
  templateUrl: './baja.component.html',
  styleUrls: ['./baja.component.css']
})
export class BajaComponent implements OnInit, AfterContentChecked  {
  @ViewChild('clienteComponent', {static: false}) cliente: ClienteComponent;
  datosVehiculos: FormGroup;
  documentos: FormGroup;
  isEditable = true;
  datoTramite: any;
  exencion: boolean;
  filesDniComprador: any[] = [];
  filesDniVendedor: any[] = [];
  filesPadron: any[] = [];
  fileMandatoComprador: any[] = [];
  fileMandatoVendedor: any[] = [];
  filesCIFComprador: any[] = [];
  filesCIFVendedor: any[] = [];
  filesPoder: any[] = [];
  fileFicha: any[] = [];
  fileFactura: any[] = [];
  filePermiso: any[] = [];
  filesNRC: any[] = [];
  file05: any[] = [];
  file06: any[] = [];
  fileIva4: any[] = [];
  fileOtros: any[] = [];
  solicitud: string;
  formData: FormData;
  observacion: any;
  provincias: any[];
  ocultar = true;
  clienteComprador: any;
  archivos: any[] = [];
  clasif: any;
  maxFileSize = 5242880;
  sumFileSize = 0;
  maxSum = 20971520;
  hoy = new Date();
  spinnerEITV = false;


  constructor(private cdRef: ChangeDetectorRef, private fb: FormBuilder, private servicio: PageService, private snackbar: MatSnackBar,
              public dialog: MatDialog, private router: Router, private modalInjector: ModalInjectorService) {

  }


  ngOnInit(): void {
    this.inicio();
    this.getUploadSize();
  }



  getUploadSize(): void{
    this.servicio.getUploadSize().subscribe( res => {
      this.maxSum = res['maxUploadSize'];
      this.maxFileSize = res['maxFileSize'];
    });
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  get datosCliente(): any {
    return this.cliente ? this.cliente.cliente$ : null;
  }

  get matriculaNoValido(): any {
    return this.datosVehiculos.get('matricula').invalid && this.datosVehiculos.get('matricula').touched;
  }

  get bastidorNoValido(): any {
    return this.datosVehiculos.get('bastidor').invalid && this.datosVehiculos.get('bastidor').touched;
  }

  get marcaNoValido(): any {
    return this.datosVehiculos.get('marca').invalid && this.datosVehiculos.get('marca').touched;
  }

  get modeloNoValido(): any {
    return this.datosVehiculos.get('modelo').invalid && this.datosVehiculos.get('modelo').touched;
  }

  inicio(): void {
    this.solicitud = sessionStorage.getItem('id');
    sessionStorage.setItem('tipoCliente', '1');
    this.clasificaciones();
    this.getProvincia();
    if (sessionStorage.getItem('colaborador') === 'null') {
      this.router.navigate(['page/home']);
    }
    this.crearFormulario();
    if (this.solicitud !== 'null') {
      console.log('aca');
      this.getSolicitud();
    }
  }

  crearFormulario(): any {
    this.datosVehiculos = this.fb.group({
      tipo: '',
      colaborador: '',
      usuarioweb: '',
      matricula: ['', [Validators.required]],
      bastidor: ['', [Validators.required]],
      tipoVehiculo: '10',
      marca: '',
      modelo: '',
      fechaMatriculacion: null,
      cilindrada: ['', [Validators.required]],
      potenciaFiscal: ['', [Validators.required]],
      cv: ['', [Validators.required]],
      co2: '',
    });

  }

  getProvincia(): void {
    this.servicio.getProvincia()
      .subscribe(async (res) => {
          console.log(res);
          this.provincias = await res;
        }, (error) => {
          console.log(error);
        }
      );
  }

  onFileDropped($event, numero): any {
    const ok = this.checkExtension($event);
    const size = this.checkSize($event[0]);
    if (ok && size) {

      this.prepareFilesList($event, numero);
    }
  }

  checkExtension(file: Array<any>): boolean {
    const fileNombre = file[0].name.toLowerCase();
    const regex = new RegExp('(.*?)\.(jpg|jpeg|png|pdf)$');
    return regex.test(fileNombre);
  }

  fileBrowseHandler(files, numero): any {
    let i = 0;
    const arrFiles = Array.from(files);
    for (const file of files){
      const ok = this.checkSize(file);
      if ( !ok ){
        arrFiles.splice(i, 1);
      }
      i++;
    }
    if ( files.length !== 0 ){
      this.prepareFilesList(arrFiles, numero);
    }

  }

  prepareFilesList(files: Array<any>, numero): any {

    this.archivos.push(files);


    if (numero === 0 && this.filesDniComprador.length < 2) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)){
          this.filesDniComprador.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.filesDniComprador);
    }
    if (numero === 1 && this.filesDniVendedor.length < 2) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)){
          this.filesDniVendedor.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }

      }
      this.uploadFilesSimulator(0, this.filesDniVendedor);
    }
    if (numero === 2 && this.fileMandatoComprador.length < 2) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)){
          this.fileMandatoComprador.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }

      }
      this.uploadFilesSimulator(0, this.fileMandatoComprador);
    }
    if (numero === 3 && this.fileMandatoVendedor.length < 2) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileMandatoVendedor.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileMandatoVendedor);
    }
    if (numero === 4 && this.filesCIFComprador.length < 2) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.filesCIFComprador.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.filesCIFComprador);
    }
    if (numero === 5 && this.filesCIFVendedor.length < 2) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.filesCIFVendedor.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.filesCIFVendedor);
    }
    if (numero === 6 && this.filesPoder.length < 2) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.filesPoder.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.filesPoder);
    }
    if (numero === 7 && this.fileFactura.length < 2) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileFactura.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileFactura);
    }
    if (numero === 8 && this.fileFicha.length < 2) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileFicha.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileFicha);
    }
    if (numero === 9 && this.filePermiso.length < 2) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.filePermiso.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.filePermiso);
    }
    if (numero === 10 && this.filesPadron.length < 2) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.filesPadron.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.filesPadron);
    }
    if (numero === 11 && this.filesNRC.length < 2) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.filesNRC.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.filesNRC);
    }
    if (numero === 12) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.file05.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.file05);
    }
    if (numero === 13) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.file06.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.file06);
    }
    if (numero === 14) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileIva4.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileIva4);
    }
    if (numero === 15) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileOtros.push(item);
          Array.from(files).forEach(f => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileOtros);
    }
  }

  deleteFile(index: number, numero): any {
    const  f = this.archivos[index];
    this.sumFileSize -= f[0].size;
    this.archivos.splice(index, 1);
    if (numero === 0) {
      this.filesDniComprador.splice(index, 1);
    }
    if (numero === 1) {
      this.filesDniVendedor.splice(index, 1);
    }
    if (numero === 2) {
      this.fileMandatoComprador.splice(index, 1);
    }
    if (numero === 3) {
      this.fileMandatoVendedor.splice(index, 1);
    }
    if (numero === 4) {
      this.filesCIFComprador.splice(index, 1);
    }
    if (numero === 5) {
      this.filesCIFVendedor.splice(index, 1);
    }
    if (numero === 6) {
      this.filesPoder.splice(index, 1);
    }
    if (numero === 7) {
      this.fileFactura.splice(index, 1);
    }
    if (numero === 8) {
      this.fileFicha.splice(index, 1);
    }
    if (numero === 9) {
      this.filePermiso.splice(index, 1);
    }
    if (numero === 10) {
      this.filesPadron.splice(index, 1);
    }
    if (numero === 11) {
      this.filesNRC.splice(index, 1);
    }
    if (numero === 12) {
      this.file05.splice(index, 1);
    }
    if (numero === 13) {
      this.file06.splice(index, 1);
    }
    if (numero === 14) {
      this.fileIva4.splice(index, 1);
    }
    if (numero === 15) {
      this.fileOtros.splice(index, 1);
    }
  }

  uploadFilesSimulator(index: number, datos: Array<any>): any {
    setTimeout(() => {
      if (index === datos.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (!datos[index]) {
            clearInterval(progressInterval);
            return;
          }
          if (datos[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1, datos);
          } else {
            datos[index].progress += 50;
          }
        }, 100);
      }
    }, 600);
  }

  formatBytes(bytes, decimals?): any {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  files(): any {
    this.formData = new FormData();
    this.filePermiso.forEach((item, i) => {
      this.formData.append('16-' + i, this.filePermiso[i]);
    });
    this.fileFicha.forEach((item, i) => {
      this.formData.append('17-' + i, this.fileFicha[i]);
    });
    this.file05.forEach((item, i) => {
      this.formData.append('18-' + i, this.file05[i]);
    });
    this.file06.forEach((item, i) => {
      this.formData.append('19-' + i, this.file06[i]);
    });
    this.filesCIFComprador.forEach((item, i) => {
      this.formData.append('27-' + i, this.filesCIFComprador[i]);
    });
    this.filesCIFVendedor.forEach((item, i) => {
      this.formData.append('28-' + i, this.filesCIFVendedor[i]);
    });
    this.fileFactura.forEach((item, i) => {
      this.formData.append('29-' + i, this.fileFactura[i]);
    });
    this.filesDniComprador.forEach((item, i) => {
      this.formData.append('30-' + i, this.filesDniComprador[i]);
    });
    this.filesDniVendedor.forEach((item, i) => {
      this.formData.append('31-' + i, this.filesDniVendedor[i]);
    });
    this.filesPadron.forEach((item, i) => {
      this.formData.append('32-' + i, this.filesPadron[i]);
    });
    this.fileMandatoComprador.forEach((item, i) => {
      this.formData.append('33-' + i, this.fileMandatoComprador[i]);
    });
    this.fileMandatoVendedor.forEach((item, i) => {
      this.formData.append('34-' + i, this.fileMandatoVendedor[i]);
    });
    this.filesPoder.forEach((item, i) => {
      this.formData.append('35-' + i, this.filesPoder[i]);
    });
    this.filesNRC.forEach((item, i) => {
      this.formData.append('36-' + i, this.filesNRC[i]);
    });
    this.fileIva4.forEach((item, i) => {
      this.formData.append('37-' + i, this.fileIva4[i]);
    });
    this.fileOtros.forEach((item, i) => {
      this.formData.append('38-' + i, this.fileOtros[i]);
    });
  }

  siguiente(): void {
    this.datoTramite = {...this.clienteComprador, ...this.datosVehiculos.value};
    console.log(this.datoTramite);
  }

  siguiente2($event: any): void {
    this.clienteComprador = $event;
  }

  guardar(): void {
    if (this.maxSum < this.sumFileSize){
      Swal.fire({

        icon: 'error',

        html:

          'El tamaño total de los archivos no debe ser superior a <u>' + this.formatBytes(this.maxSum) + '</u>.' ,
        confirmButtonColor: '#5A1727',
        confirmButtonText:
          'Aceptar',
      });
      return;
    }
    this.files();
    this.datoTramite.tipo = sessionStorage.getItem('tipo');
    const dialogRef = this.dialog.open(ObservacionModalComponent, {
      width: '400px',
      data: this.datoTramite,
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog'
    });
    dialogRef.afterClosed().subscribe(result => {
      this.datoTramite.observaciones = result;
      this.datoTramite.docu = {};
      const c = this.clasif.find(res => res.id === this.datosVehiculos.value.tipoVehiculo);
      this.datoTramite.tipoVehiculo = c.descripcion;
      this.datoTramite.numPedido = sessionStorage.getItem('numPedido');
      this.datoTramite.tipo = sessionStorage.getItem('tipo');
      this.datoTramite.colaborador = sessionStorage.getItem('colaborador');
      this.datoTramite.usuarioweb = sessionStorage.getItem('email');
      this.datoTramite.paisDestino = sessionStorage.getItem('paisDestino');
      console.log(this.datoTramite);
      Object.keys(this.datoTramite).forEach(key => {
        if (this.datoTramite[key] !== null && this.datoTramite[key] !== undefined) {
          this.formData.append(key, this.datoTramite[key]);
        }
      });

      if (result.chekeado === true){
        this.servicio.add_file(this.formData).subscribe((res) => {
          console.log(res);
          Swal.fire('', 'Los datos se han guardado', 'success');
          this.router.navigate(['page/solicitudes']);
        }, (error) => {
          console.log(error);
          if (error.status === 202){
            Swal.fire('', 'La solicitud se ha guardado, pero hubo un error al subir los archivos! ', 'warning');
            this.router.navigate(['page/solicitudes']);
          }
          else if (error.status === 412){
            Swal.fire('', error.error, 'warning');
            this.router.navigate(['page/solicitudes']);
          } else {
            Swal.fire('', error.error.message, 'warning');
          }
        });
      }
    });

  }


  getSolicitud(): void {
    this.servicio.getOneSolicitud(this.solicitud).subscribe((res) => {
      this.setDatos(res);
    }, (error) => {
      console.log(error);
    });
  }

 getRespuesta(condition): string {
    let v = '';
    switch (condition) {
      case false:
        v = '0';
        break;
      case true:
        v = '1';
        break;
    }
    return v;
  }

  getVehiculo(): void {
    if (this.datosVehiculos.value.matricula.length > 5) {
      this.servicio.getOneVehiculo(this.datosVehiculos.value.matricula).subscribe((res) => {
        console.log(res);
        if (res.matricula === this.datosVehiculos.value.matricula ){
          if (res.vehiculo != null){
            this.setDatos(res.vehiculo);
          }else{
            this.datosVehiculos.setValue({
              tipo: '',
              colaborador: '',
              matricula: this.datosVehiculos.value.matricula?.toUpperCase().trim(),
              usuarioweb: '',
              bastidor: '',
              tipoVehiculo: '10',
              marca: '',
              modelo: '',
              fechaMatriculacion: null,
              cilindrada: '',
              potenciaFiscal: '',
              cv: '',
              co2: null,
            });
          }

        }
      }, (error) => {
        console.log(error);
      });
    }else if (this.datosVehiculos.value.matricula.length < 4){
      this.datosVehiculos.setValue({
        tipo: '',
        colaborador: '',
        matricula: this.datosVehiculos.value.matricula?.toUpperCase().trim(),
        usuarioweb: '',
        bastidor: '',
        tipoVehiculo: '10',
        marca: '',
        modelo: '',
        fechaMatriculacion: null,
        cilindrada: '',
        potenciaFiscal: '',
        cv: '',
        co2: null,
      });
    }
  }

  setDatos(datos): any {
    this.datosVehiculos.controls.matricula.setValue(datos.matricula);
    this.datosVehiculos.controls.bastidor.setValue(datos.bastidor);
    this.datosVehiculos.controls.marca.setValue(datos.marca);
    this.datosVehiculos.controls.modelo.setValue(datos.modelo);
    if (datos.clasificacion !== null) {
      const clasif = datos.clasificacion.slice(0, 2);
      this.datosVehiculos.controls.tipoVehiculo.setValue(clasif);
      console.log(this.datosVehiculos.value.tipoVehiculo);
    } else {
      this.datosVehiculos.controls.tipoVehiculo.setValue('10');
    }
    this.datosVehiculos.controls.fechaMatriculacion.setValue(datos.fechaMatriculacion);
    this.datosVehiculos.controls.potenciaFiscal.setValue(datos.hp);
    this.datosVehiculos.controls.cv.setValue(datos.potencianetaitv);
    this.datosVehiculos.controls.cilindrada.setValue(datos.cilindrada);
    this.datosVehiculos.controls.co2.setValue(datos.co2);


      this.snackbar.open('Información del vehículo autocompletada, por favor, revise los datos.', 'OK', {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'snack-cliente',
        duration: 3500
      });
  }

  clasificaciones(): void {
    this.clasif = [{id: '03', descripcion: '03xx – CICLOMOTOR'}, {id: '04', descripcion: '04xx – MOTOCICLETA'},
      {id: '06', descripcion: '06xx – AUTOMOVIL DE TRES RUEDAS'}, {id: '10', descripcion: '10xx – TURISMO'},
      {id: '17', descripcion: '17xx – PICK UP'}, {id: '20', descripcion: '20xx – CAMION MMA <=3.500 kg'},
      {id: '21', descripcion: '21xx – CAMION 3.500 kg. < MMA <= 12.500 kg'}, {id: '22', descripcion: '22xx – CAMION MMA > 12.000 kg'},
      {id: '24', descripcion: '24xx – FURGON/FURGONETA MMA <= 3.500 kg'}, {id: '31', descripcion: '31xx – VEHICULO MIXTO ADAPTABLE'},
      {id: '32', descripcion: '32xx – AUTO-CARAVANA MMA <= 3.500 kg'}, {id: '33', descripcion: '33xx – AUTO-CARAVANA MMA > 3.500 kg'},
      {id: '66', descripcion: '66xx – QUAD ATV'}
    ];
  }

  checkSize(file): boolean {

    if (file.size > this.maxFileSize){
      console.log('Archivo demasiado grande');
      Swal.fire({

        icon: 'error',

        html:
          'Nombre: ' + '<b>' + file.name + '</b> Tamaño: <b>' + this.formatBytes(file.size) + '</b> <br>' +
          'El archivo no debe superar los <u>5MB</u>.' ,
        confirmButtonColor: '#5A1727',
        confirmButtonText:
          'Aceptar',
      });
      return false;
    }


    return  true;
  }

  getDatosEITV(): void{
    if(this.datosVehiculos.get('bastidor').value=="" || this.datosVehiculos.get('bastidor').invalid)
    {
      Swal.fire('', 'Se necesita un bastidor válido para recuperar los datos del vehículo desde la DGT', 'warning');
    }
    else{
      this.spinnerEITV=true;
      this.servicio.getEITV(this.datosVehiculos.get('bastidor').value).subscribe({
        next: value => {
          console.log(value.content);
          if(value.error=='ERROR')
            Swal.fire('', 'Error recuperando los datos: '+value.content+ '. Por favor rellene manualmente los datos.', 'warning');
          else
          {
            Swal.fire('', 'Datos EITV recuperados con éxito', 'success');
            console.log(value.content.datos.EMISION_CO2);
            this.datosVehiculos.controls.co2.setValue((parseInt(value.content.datos.EMISION_CO2)/1000).toFixed(0));
            this.datosVehiculos.controls.tipoVehiculo.setValue(value.content.datos.CLASIFICACION_VEHICULO.slice(0, 2));
            this.datosVehiculos.controls.cv.setValue((parseInt(value.content.datos.POTENCIA_NETA)/1000).toString());
            //this.datosVehiculos.controls.cv.setValue((parseInt(value.content.datos.POTENCIA_NETA)/1000).toFixed(3).toString().padStart(13,"0"));
            this.datosVehiculos.controls.potenciaFiscal.setValue(value.content.datos.POTENCIA_FISCAL/100);
            this.datosVehiculos.controls.cilindrada.setValue(value.content.datos.CILINDRADA.replace(/^0+/, ''));
            this.datosVehiculos.controls.marca.setValue(value.content.datos.MARCA);
            this.datosVehiculos.controls.modelo.setValue(value.content.datos.MODELO);
            //this.datosVehiculos.controls.matricula.setValue(value.content.datos.MATRICULA);
          }
        },
        error: err => {
          console.log(err);
          Swal.fire('', 'Imposible conectar con la DGT, por favor compruebe el bastidor y si es correcto rellene manualmente los datos del vehículo', 'warning');
        },
        complete: () => {
          this.spinnerEITV = false;
        }
      });
    }
  }

}
